/* import __COLOCATED_TEMPLATE__ from './user-and-avatar.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();